/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verification_Unknown_ErrorInputs */

const en_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown error occurred. Please try again.`)
};

const id_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjadi kesalahan yang tidak dikenal. Coba lagi.`)
};

const ms_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat yang tidak diketahui berlaku. Sila cuba lagi.`)
};

const ca_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'ha produït un error desconegut. Si us plau, torna-ho a intentar.`)
};

const cs_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Došlo k neznámé chybě. Zkuste to znovu.`)
};

const da_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der opstod en ukendt fejl. Prøv venligst igen.`)
};

const de_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein unbekannter Fehler ist aufgetreten. Bitte versuche es erneut.`)
};

const et_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekkis tundmatu tõrge. Palun proovige uuesti.`)
};

const es_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocurrió un error desconocido. Vuelve a intentarlo.`)
};

const fr_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur inconnue est survenue. Veuillez réessayer.`)
};

const hr_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Došlo je do nepoznate pogreške. Pokušajte ponovno.`)
};

const it_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore sconosciuto, riprova più tardi.`)
};

const lv_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notikusi nezināma kļūda. Lūdzu, mēģiniet vēlreiz.`)
};

const lt_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Įvyko nežinoma klaida. Bandykite dar kartą.`)
};

const hu_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismeretlen hiba történt. Kérjük, próbálja meg újra.`)
};

const nl_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekende fout opgetreden. Probeer het opnieuw.`)
};

const nb_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En ukjent feil oppstod. Prøv på nytt.`)
};

const pl_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wystąpił nieznany błąd. Spróbuj ponownie.`)
};

const pt_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro desconhecido. Tente novamente.`)
};

const ro_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare necunoscută. Te rugăm să încerci din nou.`)
};

const sk_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyskytla sa neznáma chyba. Skúste to prosím znova.`)
};

const sl_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prišlo je do neznane napake. Poskusite znova.`)
};

const fi_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapahtui tuntematon virhe. Yritä uudelleen.`)
};

const sv_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okänt fel inträffade. Vänligen försök igen.`)
};

const vi_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xảy ra lỗi không xác định. Vui lòng thử lại.`)
};

const tr_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen bir hata oluştu. Lütfen tekrar deneyin.`)
};

const el_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εμφανίστηκε άγνωστο σφάλμα. Προσπαθήστε ξανά.`)
};

const bg_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Възникна неизвестна грешка. Моля, опитай отново.`)
};

const ru_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Произошла неизвестная ошибка. Пожалуйста, попробуйте еще раз.`)
};

const sr_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дошло је до непознате грешке. Пробајте поново.`)
};

const uk_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виникла невідома помилка. Будь ласка, спробуйте ще раз.`)
};

const ka_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაფიქსირდა გაუთვალისწინებელი ხარვეზი. გთხოვთ, სცადოთ ხელახლა.`)
};

const hi_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अननोन एरर। कृपया फिर से कोशिश करें।`)
};

const th_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ ลองใหม่อีกครั้ง`)
};

const ko_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알 수 없는 오류가 발생했습니다. 다시 시도하세요.`)
};

const zh_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发生了未知错误。请重试。`)
};

const zh_tw_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發生未知錯誤。請再試一次。`)
};

const ja_verification_unknown_error = /** @type {(inputs: Verification_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明なエラーが発生しました。もう一度やり直してください。`)
};

/**
* | output |
* | --- |
* | "Unknown error occurred. Please try again." |
*
* @param {Verification_Unknown_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const verification_unknown_error = /** @type {((inputs?: Verification_Unknown_ErrorInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verification_Unknown_ErrorInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_verification_unknown_error(inputs)
	if (locale === "ms") return ms_verification_unknown_error(inputs)
	if (locale === "ca") return ca_verification_unknown_error(inputs)
	if (locale === "cs") return cs_verification_unknown_error(inputs)
	if (locale === "da") return da_verification_unknown_error(inputs)
	if (locale === "de") return de_verification_unknown_error(inputs)
	if (locale === "et") return et_verification_unknown_error(inputs)
	if (locale === "es") return es_verification_unknown_error(inputs)
	if (locale === "fr") return fr_verification_unknown_error(inputs)
	if (locale === "hr") return hr_verification_unknown_error(inputs)
	if (locale === "it") return it_verification_unknown_error(inputs)
	if (locale === "lv") return lv_verification_unknown_error(inputs)
	if (locale === "lt") return lt_verification_unknown_error(inputs)
	if (locale === "hu") return hu_verification_unknown_error(inputs)
	if (locale === "nl") return nl_verification_unknown_error(inputs)
	if (locale === "nb") return nb_verification_unknown_error(inputs)
	if (locale === "pl") return pl_verification_unknown_error(inputs)
	if (locale === "pt") return pt_verification_unknown_error(inputs)
	if (locale === "ro") return ro_verification_unknown_error(inputs)
	if (locale === "sk") return sk_verification_unknown_error(inputs)
	if (locale === "sl") return sl_verification_unknown_error(inputs)
	if (locale === "fi") return fi_verification_unknown_error(inputs)
	if (locale === "sv") return sv_verification_unknown_error(inputs)
	if (locale === "vi") return vi_verification_unknown_error(inputs)
	if (locale === "tr") return tr_verification_unknown_error(inputs)
	if (locale === "el") return el_verification_unknown_error(inputs)
	if (locale === "bg") return bg_verification_unknown_error(inputs)
	if (locale === "ru") return ru_verification_unknown_error(inputs)
	if (locale === "sr") return sr_verification_unknown_error(inputs)
	if (locale === "uk") return uk_verification_unknown_error(inputs)
	if (locale === "ka") return ka_verification_unknown_error(inputs)
	if (locale === "hi") return hi_verification_unknown_error(inputs)
	if (locale === "th") return th_verification_unknown_error(inputs)
	if (locale === "ko") return ko_verification_unknown_error(inputs)
	if (locale === "zh") return zh_verification_unknown_error(inputs)
	if (locale === "zh-tw") return zh_tw_verification_unknown_error(inputs)
	if (locale === "ja") return ja_verification_unknown_error(inputs)
	return en_verification_unknown_error(inputs)
});